<template>
  <div class="uar_tab">
    <ul class="clear">
      <li>
        <router-link :to="{ name:'friend.index'}" :class="{'current': position=='index'}">我的好友</router-link>
      </li>
      <li>
        <router-link :to="{ name:'friend.request'}" :class="{'current': position=='request'}">好友请求</router-link>
      </li>
      <li>
        <router-link :to="{ name:'friend.black'}" :class="{'current': position=='black'}">黑名单</router-link>
      </li>
      <li>
        <router-link :to="{ name:'friend.fans'}" :class="{'current': position=='fans'}">我的粉丝</router-link>
      </li>
      <li>
        <router-link :to="{ name:'friend.follow'}" :class="{'current': position=='follow'}">我的关注</router-link>
      </li>
      <li>
        <router-link :to="{ name:'friend.visitor'}" :class="{'current': position=='visitor'}">我的访客</router-link>
      </li>
      <li>
        <router-link :to="{ name:'friend.visit'}" :class="{'current': position=='visit'}">我的访问</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    position: String
  }
};
</script>

<style scoped>
</style>